import { Box, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ApplicationProps, BrokerList } from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { KeyValue } from '../ApplicationDetails/contributor';
import { Gridstyles } from '../ApplicationDetails';
import { SubHeading } from '../investors/components';
import {
  checkSourceOfFundOthers,
  checkValidationBasedOnDate,
  currencyConversion,
  getclIdField,
  getdpIdField,
  getIsServiceRequired,
  isCDSL,
  isDprFieldApplicable,
  OthersOptionForRE,
  reTypeNAOption,
  shouldShowRBICategory,
} from '../../utils/utilityFunctions';
import {
  investorTypeMasters,
  DLCLMasters,
  SourceOfFundMaster,
  sourceOfFundFieldValidationDate,
  USER_ROLES,
  AOI_BOI_MASTER,
  accredidateValidationDate,
  npoValidationDate,
  yesNoMaster,
  REtypeMaster,
  reTypeValidationDate,
  nbfcValidationDate,
  servicesMaster,
  serviceValidationDate,
} from '../../utils/constant';
import { useDispatch, useSelector } from 'react-redux';
import { getBrokers } from '../../redux-store/actions/application';
import { RootStateType } from '../../redux-store/reducers';
import { isNotNpoDeclaration, isNpoDeclaration } from '../../utils/declaration';

export default function ContributorDetails({
  application,
  ifXalt,
  isAccreditedInvestor,
  isEmployeeOrSponsor,
}: {
  application: ApplicationProps;
  ifXalt: boolean;
  isAccreditedInvestor?: boolean;
  isEmployeeOrSponsor?: boolean;
}): JSX.Element {
  const dispatch = useDispatch();
  const [brokerList, setBrokerList] = useState<BrokerList>();
  const { createdAt = '', applicants = [], ppmNo = null } = application || {};
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(getBrokers())) as unknown as BrokerList;
        setBrokerList(response as BrokerList);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
                Contributor Details
              </Typography>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              sx={{ mt: 1 }}>
              <Typography
                sx={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: 'text.secondary',
                }}>
                Employee or Sponsor:{' '}
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 500,
                    fontSize: '16px',
                    color: 'rgba(0, 0, 0, 0.6)',
                    letterSpacing: '0.4px',
                    ml: 0.5,
                  }}>
                  {isEmployeeOrSponsor ? 'Yes' : 'No'}
                </Typography>
              </Typography>
            </Grid>
            {checkValidationBasedOnDate(application.createdAt || '', accredidateValidationDate) && (
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
                sx={{ mt: 1 }}>
                <Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: 'text.secondary',
                  }}>
                  Accredited Investor:{' '}
                  <Typography
                    component="span"
                    sx={{
                      fontWeight: 500,
                      fontSize: '16px',
                      color: 'rgba(0, 0, 0, 0.6)',
                      letterSpacing: '0.4px',
                      ml: 0.5,
                    }}>
                    {isAccreditedInvestor ? 'Yes' : 'No'}
                  </Typography>
                </Typography>
              </Grid>
            )}
            <Box sx={{ width: '100%' }}>
              <Gridstyles>
                <Grid
                  item
                  container
                  pb={5}
                  rowSpacing={6}
                  columnSpacing={13}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="flex-start">
                  <KeyValue title={'PPM No'} description={ppmNo} />
                </Grid>
              </Gridstyles>
            </Box>
            {applicants.map((applicant) => {
              const isServicesRequired = getIsServiceRequired(applicant);
              return (
                <React.Fragment key={applicant.id}>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={13}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue title={'Name Of Entity'} description={applicant.name} />
                      <KeyValue
                        title={'Date of Registration/Incorporation'}
                        description={formatShortDate(applicant.dateOfBirth)}
                        sx={{ overflowWrap: 'anywhere' }}
                      />
                      <KeyValue
                        title={'Place of Registration/Incorporation'}
                        description={applicant.cityOfIncorporation}
                        sx={{ overflowWrap: 'anywhere' }}
                      />
                      <KeyValue
                        title={'CKYC No./CKYC Acknowledge No./KIN No'}
                        description={applicant.ckycNo}
                      />
                      {applicant.investorType && (
                        <KeyValue
                          title={'Investor Type'}
                          description={investorTypeMasters[applicant.investorType]}
                        />
                      )}
                      {/* {ifXalt &&
                        investorTypeMasters[applicant?.investorType || ''] ===
                          investorTypeMasters.boi_or_aop && (
                          <KeyValue
                            title={'AOP or BOI'}
                            description={AOI_BOI_MASTER[applicant?.boiOrAop || '']}
                          />
                        )} */}
                      <KeyValue title={'PAN'} description={applicant.panNo} />
                      {isAccreditedInvestor &&
                        checkValidationBasedOnDate(
                          application?.createdAt || '',
                          accredidateValidationDate
                        ) && (
                          <>
                            <KeyValue
                              title={'Accreditation Certificate Number'}
                              description={applicant.accreditationCertificateNumber}
                            />
                            <KeyValue
                              title={'Accreditation Certificate Start Date'}
                              description={formatShortDate(applicant.accreditationValidFrom)}
                            />
                            <KeyValue
                              title={'Accreditation Certificate End Date'}
                              description={formatShortDate(applicant.accreditationValidTo)}
                            />
                          </>
                        )}
                      {['corporate', 'bank', 'institutional_investor'].includes(
                        applicant.investorType || ''
                      ) &&
                        applicant.isNbfc &&
                        checkValidationBasedOnDate(
                          application.createdAt || '',
                          nbfcValidationDate
                        ) && (
                          <KeyValue
                            title={'Is NBFCs (including Housing Finance Companies)'}
                            description={yesNoMaster[applicant.isNbfc]}
                          />
                        )}
                      {checkValidationBasedOnDate(
                        application.createdAt || '',
                        reTypeValidationDate
                      ) && (
                        <>
                          <KeyValue
                            title={'RBI Regulated Entity'}
                            description={yesNoMaster[applicant.rbiRegulatedEntity || '']}
                          />
                          {shouldShowRBICategory(applicant.rbiRegulatedEntity || '') && (
                            <>
                              <KeyValue
                                title={'RE Type'}
                                description={REtypeMaster[applicant.reType || '']}
                              />
                              {applicant.reType && (
                                <KeyValue
                                  title={'RBI Registration Number'}
                                  description={applicant.RBIRegNo}
                                />
                              )}
                              {/* {OthersOptionForRE(applicant.reType || '') && (
                            <KeyValue
                              title={'Other RE Type'}
                              description={applicant.reTypeOthers}
                            />
                          )} */}
                            </>
                          )}
                        </>
                      )}
                      {![USER_ROLES.AUTHORISEDSIGNATORY, USER_ROLES.INVESTOR].includes(role) &&
                        applicant.kraStatus && (
                          <KeyValue title={'KRA Status'} description={applicant.kraStatus} />
                        )}
                      {applicant.kraMobileNumber && (
                        <KeyValue
                          title={'KRA Mobile Number'}
                          description={applicant.kraMobileNumber}
                        />
                      )}
                      {applicant.kraEmailId && (
                        <KeyValue title={'KRA Email Id'} description={applicant.kraEmailId} />
                      )}
                      {investorTypeMasters[applicant.investorType || ''] ===
                        investorTypeMasters.trust &&
                        checkValidationBasedOnDate(createdAt || '', npoValidationDate) && (
                          <KeyValue
                            title={'Is NPO '}
                            description={yesNoMaster[applicant.isTrustEntity || '']}
                          />
                        )}
                      {isDprFieldApplicable(
                        applicant.investorType || '',
                        applicant.isTrustEntity || ''
                      ) &&
                        checkValidationBasedOnDate(createdAt || '', npoValidationDate) && (
                          <>
                            {applicant.isNpo && (
                              <Grid item xs={12} display="flex" alignItems={'flex-start'} mt={1}>
                                {/* <Checkbox defaultChecked disabled={true} /> */}
                                <Typography
                                  sx={{
                                    fontSize: 15,
                                    fontWeight: 700,
                                    color: 'rgba(0, 0, 0, 0.6)',
                                    letterSpacing: '0.5px',
                                  }}>
                                  {isNpoDeclaration}
                                </Typography>
                              </Grid>
                            )}

                            {applicant.isNpo && (
                              <KeyValue
                                title={'Darpan Portal Registration Number'}
                                description={applicant.darpanRegistrationNo}
                              />
                            )}
                            {applicant.isNotNpo && (
                              <Grid item xs={12} display="flex" alignItems={'flex-start'} mt={1}>
                                {/* <Checkbox defaultChecked disabled={true} /> */}
                                <Typography
                                  sx={{
                                    fontSize: 15,
                                    fontWeight: 700,
                                    color: 'rgba(0, 0, 0, 0.6)',
                                    letterSpacing: '0.5px',
                                  }}>
                                  {isNotNpoDeclaration}
                                </Typography>
                              </Grid>
                            )}
                          </>
                        )}
                    </Grid>
                  </Gridstyles>
                  <SubHeading
                    sx={{
                      color: 'common.black',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                    }}>
                    {'Other Details'}
                  </SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={21}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue
                        title={'Gross Annual Income'}
                        description={applicant.grossAnnualIncome}
                      />
                      <KeyValue
                        title={'Net Worth'}
                        description={applicant.netWorth}
                        amount={currencyConversion(applicant.netWorth)}
                      />
                      <KeyValue
                        title={'PEP Status'}
                        description={applicant.politicallyExposedPersonStatus}
                      />
                      <KeyValue
                        title={'Demat Account Details (for allotment of units)'}
                        description={DLCLMasters[applicant.dlclId || '']}
                      />
                      {checkValidationBasedOnDate(createdAt, sourceOfFundFieldValidationDate) && (
                        <KeyValue
                          title={'Source Of Funds'}
                          description={
                            applicant.sourceOfFunds &&
                            checkSourceOfFundOthers(applicant.sourceOfFunds)
                              ? applicant.sourceOfFundsOthers
                              : SourceOfFundMaster[applicant.sourceOfFunds || '']
                          }
                        />
                      )}
                      {getdpIdField(applicant.dlclId || '') && (
                        <KeyValue
                          title={isCDSL(applicant.dlclId || '') ? 'DPCL ID' : 'DP ID'}
                          description={applicant.dpId}
                        />
                      )}
                      {getclIdField(applicant.dlclId || '') && (
                        <KeyValue title={'CL ID'} description={applicant.clId} />
                      )}
                      {getdpIdField(applicant.dlclId || '') && (
                        <KeyValue
                          title={'Name of Broker/Depository Participant (DP)'}
                          description={
                            brokerList?.broker_list.find(
                              (broker) => broker.key === applicant.nameOfBroker
                            )?.value
                          }
                        />
                      )}
                      {checkValidationBasedOnDate(
                        application.createdAt || '',
                        serviceValidationDate
                      ) && (
                        <KeyValue
                          title="Non-Individual investors involved/providing any of the mentioned services:"
                          description={isServicesRequired
                            ?.map((key) => servicesMaster[key])
                            .join(', ')}
                        />
                      )}
                    </Grid>
                  </Gridstyles>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
